import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=1f9e80e7&scoped=true"
import script from "./account-detail.vue?vue&type=script&lang=js"
export * from "./account-detail.vue?vue&type=script&lang=js"
import style0 from "./account-detail.vue?vue&type=style&index=0&id=1f9e80e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e80e7",
  null
  
)

export default component.exports